<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('animal.Breed_keeper') }}</h5>
    <p class="mb-0 text-sm">{{ $t('animal.Mandatory_informations') }} *</p>
    <div class="multisteps-form__content">
      <div class="row mt-3">
        <p class="fw-bold">{{ $t('animal.Breeder_details') }}</p>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Breeder') }}</label>  
            <select id="breederId" v-model="localFormData.breederId" class="form-control form-control-default">
                <option value="">{{ $t('animal.Select_breeder') }}</option>
                <option v-for="item in breederKeepers" :key="item.id" :value="String(item.id)">
                    {{ item.fullname }}
                </option>
            </select>
          </div>
        </div>        
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('animal.Breeder_name') }} *</label>
            <input v-model="localFormData.breederName" type="text" class="form-control form-control-default" :placeholder="$t('animal.Breeder_name')"> 
            <span v-if="v$.breederName.$error" class="text-sm text-danger">
              {{ v$.breederName.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-3">
          <p class="fw-bold">{{ $t('animal.Keeper_details') }}</p>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Keeper_details') }}</label>  
              <select id="keeperId" v-model="localFormData.keeperId" class="form-control form-control-default">
                  <option value="">{{ $t('animal.Select_keeper') }}</option>
                  <option v-for="item in breederKeepers" :key="item.id" :value="String(item.id)">
                      {{ item.fullname }}
                  </option>
              </select>
            </div>
          </div>          
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Keeper_name') }}</label>
              <input v-model="localFormData.keeperName" type="text" class="form-control form-control-default" :placeholder="$t('animal.Keeper_name')"> 
            </div>
          </div>
      </div>      
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="this.$parent.prevStep">{{ $t('common.Prev') }}</button>
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>                
      </div>
    </div>
  </div>
</template>

<script>
  import useVuelidate from '@vuelidate/core'
  import { required, helpers, } from '@vuelidate/validators'
  import { computed, watch, toRefs } from 'vue'
  import { useI18n } from 'vue-i18n'

  export default {
    name: "BreedKeeperSection",
    props: {
      breederKeepers: Array,
      formData: Object,
      prevStep: Function,
      nextStep: Function
    },
    setup(props, { emit }) {
      const { t } = useI18n()

      const { formData, breederKeepers } = toRefs(props)

      const localFormData = formData.value

      //const localFormData = reactive({ ...props.formData })

      watch(() => localFormData.breederId, (newId) => {
        const selectedBreeder = breederKeepers.value.find(b => String(b.id) === newId)
        if (selectedBreeder) {
          localFormData.breederName = selectedBreeder.fullname
        } else {
          localFormData.breederName = ''
        }
      })

      watch(() => localFormData.keeperId, (newId) => {
        const selectedKeeper = breederKeepers.value.find(b => String(b.id) === newId)
        if (selectedKeeper) {
          localFormData.keeperName = selectedKeeper.fullname          
        } else {
          localFormData.keeperName = ''          
        }
      })

      const rules = computed(() => ({        
        breederName: { required: helpers.withMessage(t('common.Required'), required) }
      }));

      const v$ = useVuelidate(rules, localFormData)

      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })

      const validateAndNextStep = async () => {
        v$.value.$touch() // Mark all fields as touched
        if (v$.value.$pending) {
          await v$.value.$validate() // Ensure validation completes
        }
        if (!v$.value.$invalid) {
          props.nextStep()
        }
      }

      return {
        localFormData,
        v$,
        validateAndNextStep
      }
    }    
};
</script>